import React, { Component } from 'react'
import { connect } from 'react-redux'
import UsersAPI from 'remote/users'
import { List, Map } from 'immutable'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'

import { selectors as UISelectors } from 'data/ui'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as AuthSelectors } from 'data/auth'
import { selectors as UsersSelectors } from 'data/users'

import PresenceBlock from './PresenceBlock'
import findUserPresenceBlock from '../utils/findUserPresenceBlock'

const API_DEBOUNCE_TIME = 500

class PresenceContainer extends Component {
  previousPresenceState = null

  componentDidMount() {
    this.props.pluginStore.subscribeToItem(
      'presenceState',
      this.onPresenceUpdate
    )
  }

  componentWillUnmount() {
    this.props.pluginStore.unsubscribeFromItem(
      'presenceState',
      this.onPresenceUpdate
    )
  }

  onPresenceUpdate = debounce(
    presenceState => {
      const {
        apiEndpoint,
        apiToken,
        noteId,
        numberOfUsersWatchingTheActiveNote,
      } = this.props
      const presenceHasChanged = !isEqual(
        this.previousPresenceState,
        presenceState
      )
      if (numberOfUsersWatchingTheActiveNote > 1 && presenceHasChanged) {
        UsersAPI.updateUserPresence(
          { apiEndpoint, apiToken },
          { noteId, ...presenceState }
        )
      }
      this.previousPresenceState = presenceState
    },
    API_DEBOUNCE_TIME,
    { leading: true, trailing: true }
  )

  getUserPresencesByNoteId() {
    return this.props.userPresences.reduce(
      (memo, userPresence) =>
        userPresence.get('blockId')
          ? memo.update(userPresence.get('blockId'), List(), blockPresences =>
              blockPresences.push(userPresence)
            )
          : memo,
      Map()
    )
  }

  render() {
    const { editor, pluginStore, currentUser } = this.props
    const userPresencesByBlockId = this.getUserPresencesByNoteId()

    return (
      <div className="position-absolute" style={{ top: 0 }}>
        {userPresencesByBlockId
          .map((userPresences, blockId) => {
            const block = findUserPresenceBlock(editor, blockId)
            return block ? (
              <PresenceBlock
                key={blockId}
                editor={editor}
                userPresences={userPresences}
                currentUser={currentUser}
                block={block}
                pluginStore={pluginStore}
              />
            ) : (
              false
            )
          })
          .toArray()}
      </div>
    )
  }
}

const enhance = connect(state => {
  const noteId = UISelectors.getActiveNoteId(state)
  const usersWatchingTheActiveNote = UsersSelectors.getUserPresenceByNoteId(
    state,
    noteId
  )

  return {
    noteId,
    apiEndpoint: ConfigSelectors.getApiEndpoint(state),
    apiToken: AuthSelectors.getApiToken(state),
    numberOfUsersWatchingTheActiveNote: usersWatchingTheActiveNote.size,
    currentUser: UsersSelectors.getCurrentUser(state),
    userPresences: UsersSelectors.getUserPresenceByNoteId(
      state,
      UISelectors.getActiveNoteId(state)
    ),
  }
})

export default enhance(PresenceContainer)
